import type { PostingDay } from '@/types/brand'

/** Format a `Date` as a `YYYY-MM-DD` date-only string, in local time. */
export function toISODate(date: Date): string {
  const year = String(date.getFullYear()).padStart(4, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/** Parse a `YYYY-MM-DD` date-only string into a local-time `Date` at midnight. */
export function parseISODate(value: string): Date {
  const [year, month, day] = value.split('-').map(Number)
  return new Date(year ?? 0, (month ?? 1) - 1, day ?? 0)
}

const WEEKDAY_INDEX_TO_POSTING_DAY: readonly PostingDay[] = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
]

/** The weekday a calendar date falls on. */
export function postingDayOf(date: string): PostingDay {
  const day = WEEKDAY_INDEX_TO_POSTING_DAY[parseISODate(date).getDay()]
  if (!day) throw new Error(`Unreachable: getDay() returned an out-of-range weekday for ${date}`)
  return day
}
